module.exports = __webpack_public_path__ + "img/freespin_multiplier.d5d10645.png";